document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("js-coupon_wrapper");
  const closeBtn = document.getElementById("js-coupon_close");

  if (!banner || !closeBtn) return;

  // すでに閉じた場合は何もしない
  const isClosed = localStorage.getItem("couponBanner");
  if (isClosed === "closed") return;

  // バナー表示
  banner.style.display = "block";

  // 閉じるボタン
  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    banner.style.display = "none";
    localStorage.setItem("couponBanner", "closed");
  });
});